import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://www.facebook.com/jon.torfi1',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.jontorfi.com',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'jthauksson@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
